import firebase from '@/firebase/config'
import 'firebase/firestore'

const db = firebase.firestore()

const SCORECARD_MARKERS_COLLECTION = 'scorecard_markers'

/**
 * Format a Date (or date-like value) as YYYY-MM for scorecard_markers.
 * Matches admin ScoreCard month buckets derived from examDate.
 * @param {Date|string|number} date
 * @returns {string|null}
 */
export const formatYearMonthFromExamDate = (date) => {
  if (!date) return null

  const parsed = date instanceof Date ? date : new Date(date)
  if (Number.isNaN(parsed.getTime())) return null

  return `${parsed.getFullYear()}-${String(parsed.getMonth() + 1).padStart(2, '0')}`
}

/**
 * Soft-delete scorecard_markers/{resultId} after an exam_results delete.
 * No-op if the marker is missing; errors are logged and swallowed.
 * @param {string} resultId
 * @returns {Promise<void>}
 */
export const deleteScorecardMarkerIfExists = async (resultId) => {
  if (!resultId) return

  try {
    await db.collection(SCORECARD_MARKERS_COLLECTION).doc(resultId).delete()
  } catch (error) {
    console.error('Error deleting scorecard marker (soft fail):', error)
  }
}

/**
 * If a marker exists for this exam result, update yearMonth from the new examDate.
 * Does not create markers. Soft-fails on error.
 * @param {string} resultId
 * @param {Date|string|number} examDate
 * @returns {Promise<void>}
 */
export const syncScorecardMarkerYearMonth = async (resultId, examDate) => {
  if (!resultId) return

  const yearMonth = formatYearMonthFromExamDate(examDate)
  if (!yearMonth) return

  try {
    const markerRef = db.collection(SCORECARD_MARKERS_COLLECTION).doc(resultId)
    const markerSnap = await markerRef.get()

    if (!markerSnap.exists) return

    if (markerSnap.data().yearMonth === yearMonth) return

    await markerRef.update({ yearMonth })
  } catch (error) {
    console.error('Error syncing scorecard marker yearMonth (soft fail):', error)
  }
}
